<template>
  <div class="about-page">
    <section class="section-tight">
      <div class="container about-facts-shell">
        <div class="about-facts">
          <div v-for="fact in content.facts" :key="fact.label" class="about-fact card-panel">
            <span>{{ fact.label }}</span>
            <strong>{{ fact.value }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container grid-two about-story">
        <div class="about-copy card-panel">
          <span class="eyebrow">{{ content.detailsEyebrow }}</span>
          <h2 class="section-title">{{ content.detailsTitle }}</h2>
          <div class="about-details">
            <div v-for="detail in content.details" :key="detail.label" class="about-detail">
              <strong>{{ detail.label }}</strong>
              <p v-for="line in detail.lines" :key="line">{{ line }}</p>
            </div>
          </div>
        </div>
        <div class="about-images">
          <div class="about-image card-panel">
            <img :src="content.images[0]" :alt="content.imageAltPrimary">
          </div>
          <div class="about-image card-panel">
            <img :src="content.images[1]" :alt="content.imageAltSecondary">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
var companyContent = {
  en: {
    facts: [
      { label: 'Company Name', value: 'JBC TOURS' },
      { label: 'Established', value: 'October, 2016' },
      { label: 'Capital', value: '99,000,000JPY' }
    ],
    detailsEyebrow: 'COMPANY',
    detailsTitle: 'Licensed travel operations and partner information.',
    details: [
      {
        label: 'Office',
        lines: [
          'Tokyo Branch',
          'Room 502, Kisuke Kudan-kita Building, 1-4-7 Kudan-kita, Chiyoda-ku, Tokyo 102-0073',
          'Tel: 81-3-6869-4765'
        ]
      },
      {
        label: 'Licenses / Certifications',
        lines: ['Travel Agency licensed by the Governor of Osaka Prefecture (License No. 3-2876)']
      },
      {
        label: 'Business Activities',
        lines: [
          'Travel services based on the Travel Agency Act of Japan.',
          'Planning, arrangement, and operation of inbound group travel for business inspections and corporate purposes.',
          'Planning, operation, and consulting for hotels, guesthouses, and ryokan accommodations.'
        ]
      },
      {
        label: 'Business Partners',
        lines: [
          'DMCFinder,',
          'Japan-China Friendship Association,',
          'Rakuten Bank,',
          'JTB Corporation,',
          'China Central Television,',
          'China Photographers Association'
        ]
      }
    ],
    images: [
      '/images/company1.jpg',
      '/images/company2.jpg'
    ],
    imageAltPrimary: 'JBC TOURS company profile image',
    imageAltSecondary: 'JBC TOURS Tokyo office and partner network image'
  },
  ja: {
    facts: [
      { label: '会社名', value: '日本ビジネスコンサルティング株式会社' },
      { label: '設立年', value: '2016年10月' },
      { label: '資本金', value: '９,９００万円' }
    ],
    detailsEyebrow: '会社情報',
    detailsTitle: '',
    details: [
      {
        label: '所在地',
        lines: [
          '東京支社',
          '〒102-0073 東京都千代田区九段北1-4-7 喜助九段北ビル502号室',
          'Tel:81-3-6869-4765'
        ]
      },
      {
        label: '許認可',
        lines: ['大阪府知事登録旅行業第3-2876号']
      },
      {
        label: '事業内容',
        lines: [
          '旅行業法に基づく旅行業務',
          '視察・商用等の訪日団体（インバウンド）向け旅行の企画・手配・実施',
          'ホテル・民宿・旅館など宿泊施設に関する開発企画、運営およびコンサルティング'
        ]
      },
      {
        label: '提携企業',
        lines: [
          'DMCFinder、',
          '日中友好協会、',
          '楽天銀行、',
          '株式会社JTB、',
          '中国中央テレビ局、',
          '中国撮影家協会'
        ]
      }
    ],
    images: [
      '/images/company1.jpg',
      '/images/company2.jpg'
    ],
    imageAltPrimary: '会社紹介イメージ',
    imageAltSecondary: '会社ネットワークイメージ'
  }
};

export default {
  name: 'About',
  props: {
    language: {
      type: String,
      default: 'en'
    }
  },
  computed: {
    content: function () {
      return companyContent[this.language] || companyContent.en;
    }
  }
};
</script>

<style scoped>
.about-page {
  padding-top: calc(var(--header-height) + 24px);
}

.about-page .section-tight {
  padding-bottom: 20px;
}

.about-page .section {
  padding-top: 28px;
}

.about-story {
  align-items: start;
}

.about-fact,
.about-image,
.about-copy {
  padding: 34px;
}

.about-facts-shell {
  position: relative;
}

.about-facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}

.about-fact span {
  display: block;
  margin-bottom: 12px;
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--color-accent-deep);
}

.about-fact strong {
  font-size: 24px;
  line-height: 1.5;
}

.about-copy {
  display: grid;
  gap: 24px;
}

.about-images {
  display: grid;
  gap: 20px;
}

.about-image {
  overflow: hidden;
}

.about-image img {
  height: 250px;
  object-fit: cover;
  border-radius: 20px;
}

.about-details {
  display: grid;
  gap: 20px;
}

.about-detail {
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(15, 76, 129, 0.08);
}

.about-detail:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.about-detail strong {
  display: block;
  margin-bottom: 12px;
  font-size: 18px;
}

@media (max-width: 767px) {
  .about-facts {
    grid-template-columns: 1fr;
  }
}
</style>
